import React from 'react';
import {
    Responsive,
    SimpleList,
    Datagrid,
    TextField,
    SimpleForm,
    TextInput,
    required
} from 'admin-on-rest';
import List from '../admin/List';
import Create from '../admin/Create';
import Edit from '../admin/Edit';
import EditButton from '../buttons/EditButton';
import {viewStyles} from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/maps/map';

export const fuseDistrictIcon = Icon;

/*
 * View: List
 */

// Set title for List Districts
const ListTitle = <span><Avatar icon={<Icon/>} style={viewStyles.avatar} className="avatar-title"/>Districts</span>;

const ListDescription = () => {
    return (
        <span>
            <p>A District groups Physical Locations to a geographical location or a District Manager. Districts are
                used for Sale and Inventory Reporting to keep track of Districts' progress.</p>
            <img src="img-diagram-District-List.png" alt="Diagram of Locations - Districts" style={viewStyles.diagram}/>
        </span>
    );
};

export const fuseLocationDistrictList = (props) => (
    <List {...props} title={ListTitle} desc={<ListDescription/>} sort={{field: 'name', order: 'ASC'}}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.name}
                    secondaryText={record => record.id}
                />
            }
            medium={
                <Datagrid bodyOptions={{stripedRows: false, showRowHover: true}}>
                    <TextField source="name"/>
                    <TextField source="id"/>
                    <EditButton/>
                </Datagrid>
            }
        />
    </List>
);

export const fuseLocationDistrictListViewOnly = (props) => (
    <List {...props} title={ListTitle} desc={<ListDescription/>} sort={{field: 'name', order: 'ASC'}}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.name}
                    secondaryText={record => record.id}
                />
            }
            medium={
                <Datagrid bodyOptions={{stripedRows: false, showRowHover: true}}>
                    <TextField source="name"/>
                    <TextField source="id"/>
                </Datagrid>
            }
        />
    </List>
);

/*
 * View: Create form
 */

// Set title for Create District
const CreateTitle = <span><Avatar icon={<Icon/>} style={viewStyles.avatar}
                                  className="avatar-title"/>Create a District</span>;

const CreateDescription = () => {
    return (
        <span>
            <p>A District groups Physical Locations to a geographical location or a District Manager. Districts are
                used for Sale and Inventory Reporting to keep track of Districts' progress.</p>
            <p>Create a District by adding a Name. This may be the full name of the person acting as the District
                Manager.</p>
        </span>
    );
};

/*
 * Create District form
 */
export const fuseLocationDistrictCreate = (props) => (
    <Create {...props} title={CreateTitle} desc={<CreateDescription/>}>
        <SimpleForm redirect="list">
            <TextInput source="name" label="Name of District" validate={[required]}/>
        </SimpleForm>
    </Create>
);

/*
 * View: Edit form
 */

// Set title for Edit District
const EditTitle = ({record}) => {
    return <span><Avatar icon={<Icon/>} style={viewStyles.avatar}
                         className="avatar-title"/>Edit {record ? `${record.name}` : 'District'}</span>;
};

const EditDescription = () => {
    return (
        <span>
            <p>Modify Name field below. Click <strong>Save</strong> to store this District.</p>
        </span>
    );
};

/*
 * Edit District form
 */
export const fuseLocationDistrictEdit = (props) => (
    <Edit {...props} title={<EditTitle/>} desc={<EditDescription/>}>
        <SimpleForm>
            <TextField source="id" label="District ID"/>
            <TextInput source="name" label="Name of District" validate={[required]}/>
        </SimpleForm>
    </Edit>
);



// WEBPACK FOOTER //
// ./src/Fuse/Location/district.js